import { useEffect, useState } from "react";

import { LoyaltyApi } from "@jti/rest-api";
import { useSelector } from "@jti/store/reduxHooks";
import { useLoyaltyRestrictedContent } from "@jti/ui";

interface StoreInterface {
  loyalty: {
    status: boolean;
  };
}

export const useLoyaltyStatus = (isAsync = false): boolean => {
  const loyaltyApi = LoyaltyApi.init();
  const { status } = useSelector((store: StoreInterface) => store?.loyalty);
  const [hasLoyalty, setLoyaltyStatus] = useState(false);
  const { isRestricted } = useLoyaltyRestrictedContent();

  useEffect(() => {
    if (isAsync) {
      loyaltyApi.getStatus().then((isActive: boolean) => {
        setLoyaltyStatus(isActive);
      });
    }
  }, []);
  if (isRestricted) return false;
  return isAsync ? hasLoyalty : status;
};
